// import API from '@/api';
// const User = API.get('User');

export default ({
  namespaced: true,

  state: {
    member: null,
    patient: null
  },

  getters: {
    patient: state => state.patient,
    member: state => state.member
  },

  mutations: {
    setMember(state, member) {
      state.member = member
    },
    setPatient(state, patient) {
      state.patient = patient
    },
    clearData(state) {
      state.member = null
      state.patient = null
    }
  },

  actions: {
    //
  }
})